import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from '../../atoms/FontIcon';
import { SIZE_TO_CLASSNAME, SIZES } from '../../organisms/FormBuilder/components/fieldLabel/fieldLabel.constants';
import Popover from '../popover';

// styles
import styles from './infoBadge.module.scss';
var InfoBadge = function InfoBadge(props) {
  var helpText = props.helpText,
    helpTextWidth = props.helpTextWidth,
    infoBadgeClassName = props.infoBadgeClassName,
    infoIconClassName = props.infoIconClassName,
    infoContentClassName = props.infoContentClassName,
    infoPlacement = props.infoPlacement,
    trigger = props.trigger,
    arrowPointAtCenter = props.arrowPointAtCenter;
  var popOverContentClassName = SIZE_TO_CLASSNAME[helpTextWidth] || '';
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.infoBadge, " ").concat(infoBadgeClassName)
  }, /*#__PURE__*/React.createElement(Popover, {
    placement: infoPlacement,
    trigger: trigger,
    arrowPointAtCenter: arrowPointAtCenter,
    content: /*#__PURE__*/React.createElement("span", {
      className: "flex ".concat(styles.infoContent, " ").concat(infoContentClassName, " ").concat(popOverContentClassName)
    }, helpText)
  }, /*#__PURE__*/React.createElement(FontIcon, {
    className: "cursor-pointer ".concat(styles.infoIcon, " ").concat(infoIconClassName)
  }, "icon-info")));
};
InfoBadge.propTypes = {
  infoBadgeClassName: PropTypes.string,
  helpText: PropTypes.string,
  helpTextWidth: PropTypes.string,
  infoIconClassName: PropTypes.string,
  infoContentClassName: PropTypes.string,
  infoPlacement: PropTypes.string,
  trigger: PropTypes.string,
  arrowPointAtCenter: PropTypes.bool
};
InfoBadge.defaultProps = {
  helpTextWidth: SIZES.MD,
  infoBadgeClassName: '',
  helpText: '',
  infoIconClassName: '',
  infoContentClassName: '',
  infoPlacement: 'top',
  trigger: 'hover',
  arrowPointAtCenter: undefined
};
export default InfoBadge;